import React from 'react'

function TableDictionary({dictionary, selectCount}) {
    return (
        <div className="table-dictionary">
            <table>
                <thead>
                    <tr>
                        <th>All</th>
                        <th>N</th>
                        <th>Word / Phrase</th>
                        <th>Phonetic Spelling</th>
                        <th>Translation</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dictionary.filter(item => item.idMain === parseInt(selectCount))
                        .map((item,index)=>(
                            <tr key={index}>
                                <td>{item.idAll}</td>
                                <td>{item.id}</td>
                                <td>{item.english}</td>
                                <td>{item.transciption}</td>
                                <td>{item.uzbek}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default TableDictionary
